export default "__VITE_ASSET__CZMG222Q__"